import { Component, registerComponent } from 'js/component.js';

const componentName = 'plex-global-nav';

const LANG_COOKIE_DOMAIN = '.rockwellautomation.com';
const setLangSiteCookie = (value) => {
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (365 * 1000 * 60 * 60 * 24));
    const expiryValue = value === '' ? 'Thu, 01 Jan 1970 00:00:00 UTC' : expiryDate.toUTCString();
    document.cookie = `langSite=${escape(value)};expires=${expiryValue};path=/;secure;domain=${LANG_COOKIE_DOMAIN};SameSite=strict`;
};

const mobileBreakpoint = 1024;
const tabletBreakpoint = 1280;

const tabletCenterDropdownMargin = 40;
const desktopCenterDropdownMargin = 185;

let onSearchResultPage = false;

let searchResultPage = 'https://rockwellautomation.com/en-us/search.html';

// Fixed locale list — auto-detected from the URL path segment
const LOCALES = [
    { code: 'en-us', shortLabel: 'US | EN', fullLabel: 'United States | English' },
    { code: 'de-de', shortLabel: 'DE | DE', fullLabel: 'Germany | Deutsch' },
    { code: 'it-it', shortLabel: 'IT | IT', fullLabel: 'Italy | Italiano' },
    { code: 'ja-jp', shortLabel: 'JP | JA', fullLabel: 'Japan | 日本語' },
];

export class GlobalNav extends Component {

    setup() {
        // ==========
        // Component Setup
        // ==========
        // Elements
        this.elements = {
            // Page
            body: document.body,
            header: document.querySelector('header.plex-global-nav'),
            nav: this.element.querySelector(`.${componentName}__nav`),
            overlay: this.element.querySelector(`.${componentName}__grey-overlay`),
            // Utility Header
            utilityHeader: this.element.querySelector(`.${componentName}__utility-header`),
            raQuickLinks: this.element.querySelector('ra-quick-links'),
            quicklinksWrapper: this.element.querySelector(`.${componentName}__quicklinks-wrapper`),
            quicklinksButton: this.element.querySelector(`.${componentName}__quicklinks-button`),
            quicklinksMenu: this.element.querySelector(`.${componentName}__quicklinks-menu`),
            // Main Header
            mainHeader: this.element.querySelector(`.${componentName}__main-header`),
            // Dropdown
            dropdownBackButton: this.element.querySelector(`.${componentName}__dropdown-back-button`),
            centerDropdownContainer: this.element.querySelector(`.${componentName}__center-dropdown-container`),
            dropdownLinks: this.element.querySelectorAll(`.${componentName}__dropdown-link`),
            dropdownOuterContainers: this.element.querySelectorAll(`.${componentName}__dropdown-outer-container`),
            // Search
            searchInput: this.element.querySelector(`.${componentName}__search-input`),
            searchSubmit: this.element.querySelector(`.${componentName}__search-submit`),
            centerSearchOuterContainer: this.element.querySelector(`.${componentName}__center-search-outer-container`),
            // Icon Buttons
            searchToggleButton: this.element.querySelector(`#${componentName}__search-toggle-button`),
            searchToggleButtonCloseIcon: this.element.querySelector(`.${componentName}__search-toggle-button-close-icon`),
            searchToggleButtonSearchIcon: this.element.querySelector(`.${componentName}__search-toggle-button-search-icon`),
            mobileMenuButton: this.element.querySelector(`.${componentName}__mobile-menu-button`),
            mobileMenuButtonIcons: this.element.querySelectorAll(`.${componentName}__mobile-menu-button span`),
            // Mobile
            utilityLinks: this.element.querySelector(`.${componentName}__utility-links`),
            supportButtonsContainerMobile: this.element.querySelector(`.${componentName}__support-buttons-container-mobile`),
            utilityHeaderLogoContainerMobile: this.element.querySelector(`.${componentName}__utility-header-logo-container-mobile`),
            mobileMenuIcon: this.element.querySelector(`.${componentName}__mobile-menu-icon svg`),
            mobileCloseMenuIcon: this.element.querySelector(`.${componentName}__mobile-close-icon svg`),
            // Language Selector
            languageSelectorButton: this.element.querySelector(`.${componentName}__language-selector-button`),
            languageSelectorMobileButton: this.element.querySelector(`.${componentName}__language-selector-mobile-button`),
            languageSelectorDropdown: this.element.querySelector(`.${componentName}__language-selector-dropdown`),
            languageSelectorCode: this.element.querySelector(`.${componentName}__language-selector-code`),
        };

        // Classes
        this.classes = {
            active: `${componentName}--active`,
            searchActive: `${componentName}--search-active`,
            mobileActive: `${componentName}--mobile-active`,
            dropdownActive: `${componentName}--dropdown-active`,
        };

        this.state = {
            isSearchOpen: false
        };

        searchResultPage = this.elements.searchInput.getAttribute('data-search-result-page') || searchResultPage;

        onSearchResultPage = window.location.href.includes('/search.html');

        this.headerHeight = this.elements.mainHeader.clientHeight;

        // Setup for Mobile
        const raQuickLinksMobile = this.elements.raQuickLinks.cloneNode(true);
        this.elements.utilityLinks.append(raQuickLinksMobile);
        this.elements.mobileMenuIcon.setAttribute('viewBox', '7 7 18 18');
        this.elements.mobileCloseMenuIcon.setAttribute('viewBox', '4 4 24 24');

        if (onSearchResultPage) {
            this.openSearch();
            this.elements.overlay.classList.remove(this.classes.active);
            this.element.classList.add(this.classes.searchActive);
        }

        // Adjusting Dropdown Container Position if Header is Pushed Down
        setTimeout(() => {
            this.repositionDropdownContainer();
        }, 5000);
    }

    // ==========
    // Quicklinks Menu
    // ==========
    openQuicklinksMenu = () => {
        this.elements.quicklinksMenu.classList.add(this.classes.active);
        this.elements.quicklinksButton.classList.add(this.classes.active);
        this.repositionDropdownContainer();
    };

    closeQuicklinksMenu = () => {
        this.elements.quicklinksMenu.classList.remove(this.classes.active);
        this.elements.quicklinksButton.classList.remove(this.classes.active);
        if (document.activeElement === this.elements.quicklinksButton) {
            this.elements.quicklinksButton.blur();
        }
    };

    handleQuicklinksButton = () => {
        this.closeDropdowns();
        this.closeMobileMenu();
        this.closeLanguageSelector();

        if (this.elements.quicklinksButton.classList.contains(this.classes.active)) {
            this.closeQuicklinksMenu();
        } else {
            this.openQuicklinksMenu();
        }
    };

    // ==========
    // Search
    // ==========
    openSearch = () => {
        if(onSearchResultPage) {
            const keywordTerm = window.location.href.includes('query_string=') ? decodeURIComponent(window.location.href.split('query_string=')[1].split('&')[0]) : '';
            this.elements.searchInput.value = keywordTerm;
        }
        this.elements.searchInput.tabIndex = 0;
        this.elements.searchSubmit.tabIndex = 0;
        this.element.classList.add(this.classes.searchActive);
        this.elements.searchToggleButton.classList.add(this.classes.active);
        this.state.isSearchOpen = true;
    };

    closeSearch = () => {
        this.elements.searchInput.tabIndex = -1;
        this.elements.searchSubmit.tabIndex = -1;
        this.element.classList.remove(this.classes.searchActive);
        this.elements.searchToggleButton.classList.remove(this.classes.active);
        this.state.isSearchOpen = false;
    };

    handleSearchButton = () => {
        this.closeDropdowns();
        this.closeMobileMenu();
        this.closeLanguageSelector();

        if (this.element.classList.contains(this.classes.searchActive)) {
            this.closeSearch();
        } else {
            this.openSearch();
            this.elements.searchInput.focus();
        }
    };

    submitSearch = (searchTerm = null) => {
        if (typeof searchTerm !== 'string') {
            const cleanSearchTerm = this.elements.searchInput.value.replace('#', '%23');
            // eslint-disable-next-line no-param-reassign
            searchTerm = cleanSearchTerm.trim();
        }
        if (searchTerm === '') {
            return;
        }
        window.location.href = `${searchResultPage}?query_string=${searchTerm}`;
    };

    // ==========
    // Dropdown Menus
    // ==========
    openDropdown = (el) => {
        this.element.classList.add(this.classes.dropdownActive);
        el.classList.add(this.classes.active);
        el.nextElementSibling.classList.add(this.classes.active);
        document.body.style.overflowY = 'hidden';

        // Close Mobile Support Buttons
        this.elements.supportButtonsContainerMobile.classList.add('inactive');
        this.elements.utilityHeaderLogoContainerMobile.classList.add('inactive');

        this.elements.overlay.classList.add(this.classes.active);
    };

    closeDropdowns = () => {
        this.element.classList.remove(this.classes.dropdownActive);
        this.elements.dropdownLinks.forEach((el) => {
            el.classList.remove(this.classes.active);
            el.blur();
        });
        this.elements.dropdownOuterContainers.forEach((el) => {
            el.classList.remove(this.classes.active);
        });
        document.body.style.overflowY = null;
        this.elements.overlay.classList.remove(this.classes.active);
    };

    handleDropdownLink = (ev) => {
        const el = ev.currentTarget;

        // Check if a direct bypass path is authored in AEM
        const navigatePath = el.getAttribute('data-navigate-to-path');
        if (navigatePath) {
            window.location.href = navigatePath;
            return;
        }

        ev.preventDefault();
        this.closeSearch();
        this.closeLanguageSelector();

        if (el.classList.contains(this.classes.active)) {
            this.closeDropdowns();
        } else {
            this.closeDropdowns();
            this.openDropdown(el);
        }
    };

    // ==========
    // Language Selector
    // ==========
    openLanguageSelector = () => {
        const dropdown = this.elements.languageSelectorDropdown;
        if (!dropdown) return;

        // Positioning is handled entirely by CSS media queries
        dropdown.classList.add(this.classes.active);
        if (this.elements.languageSelectorButton) {
            this.elements.languageSelectorButton.classList.add(this.classes.active);
            this.elements.languageSelectorButton.setAttribute('aria-expanded', 'true');
        }
        if (this.elements.languageSelectorMobileButton) {
            this.elements.languageSelectorMobileButton.classList.add(this.classes.active);
            this.elements.languageSelectorMobileButton.setAttribute('aria-expanded', 'true');
        }
    };

    closeLanguageSelector = () => {
        const dropdown = this.elements.languageSelectorDropdown;
        if (!dropdown) return;

        dropdown.classList.remove(this.classes.active);
        if (this.elements.languageSelectorButton) {
            this.elements.languageSelectorButton.classList.remove(this.classes.active);
            this.elements.languageSelectorButton.setAttribute('aria-expanded', 'false');
        }
        if (this.elements.languageSelectorMobileButton) {
            this.elements.languageSelectorMobileButton.classList.remove(this.classes.active);
            this.elements.languageSelectorMobileButton.setAttribute('aria-expanded', 'false');
        }
    };

    handleLanguageSelectorButton = () => {
        this.closeDropdowns();
        this.closeSearch();
        this.closeQuicklinksMenu();

        if (this.elements.languageSelectorDropdown?.classList.contains(this.classes.active)) {
            this.closeLanguageSelector();
        } else {
            this.openLanguageSelector();
        }
    };

    /**
     * Detect the locale from the URL path.
     * Looks for full locale codes (e.g. /en-us/, /de-de.html) anywhere in the path.
     * Returns the matching LOCALES code (e.g. 'en-us') or null.
     */
    detectLocaleFromPath = () => {
        const pathname = window.location.pathname.toLowerCase();
        const match = LOCALES.find((locale) => {
            const regex = new RegExp(`\\/${locale.code}(\\.html|\\/|$)`);
            return regex.test(pathname);
        });
        return match ? match.code : null;
    };

    /**
     * Render the locale dropdown and utility header label for a given locale code.
     * The active locale is shown as bold non-clickable text; others are clickable.
     */
    renderLocaleDropdown = (activeCode) => {
        if (!activeCode) {
            console.warn('[LocaleSelector] renderLocaleDropdown called with empty activeCode — defaulting to first locale.');
        }

        const exactMatch = LOCALES.find((l) => l.code === activeCode);
        if (!exactMatch) {
            console.warn(`[LocaleSelector] Locale code "${activeCode}" not found in LOCALES list — falling back to "${LOCALES[0].code}".`);
        }
        const activeLocale = exactMatch || LOCALES[0];

        // Update the short label in the utility header button (e.g. "US | EN")
        if (this.elements.languageSelectorCode) {
            this.elements.languageSelectorCode.textContent = activeLocale.shortLabel;
        } else {
            console.warn('[LocaleSelector] languageSelectorCode element not found — cannot update utility header label.');
        }

        // Populate the dropdown
        const dropdown = this.elements.languageSelectorDropdown;
        if (!dropdown) {
            console.error('[LocaleSelector] languageSelectorDropdown element not found — cannot render locale options.');
            return;
        }
        dropdown.innerHTML = '';

        console.info(`[LocaleSelector] Rendering dropdown — active locale: "${activeLocale.code}" (${activeLocale.fullLabel})`);

        LOCALES.forEach((locale) => {
            if (locale.code === activeLocale.code) {
                // Active locale — bold non-clickable
                const span = document.createElement('span');
                span.className = `${componentName}__language-selector-current`;
                span.textContent = locale.fullLabel;
                dropdown.appendChild(span);
            } else {
                // Other locales — clickable links
                const a = document.createElement('a');
                a.className = `${componentName}__language-selector-option`;
                a.setAttribute('role', 'menuitem');
                a.href = '#';
                a.dataset.localeCode = locale.code;
                a.textContent = locale.fullLabel;
                a.addEventListener('click', this.handleLocaleOptionClick);
                dropdown.appendChild(a);
            }
        });
    };

    /**
     * Detect the current locale from the URL and render the selector.
     *
     * This intentionally does NOT write the langSite cookie. Landing on a
     * localized URL directly (e.g. a shared/deep link to /it-it.html) must
     * leave the shared preference untouched. The cookie is only written when
     * the visitor makes an explicit choice or is geo-detected:
     *   1. picking a locale in this dropdown (handleLocaleOptionClick),
     *   2. choosing a language on the language-selector page
     *      (static-country-list.js / the ?langSite= param in lang-preference.js),
     *   3. IP/geo detection on the site root (country-locale-mapping.html).
     */
    initLocaleSelector = () => {
        const detectedCode = this.detectLocaleFromPath();

        if (detectedCode) {
            console.info(`[LocaleSelector] Detected locale from URL path: "${detectedCode}"`);
        } else {
            console.warn(`[LocaleSelector] No locale (xx-xx) found in URL path "${window.location.pathname}" — using default "${LOCALES[0].code}".`);
        }

        this.renderLocaleDropdown(detectedCode || '');
    };

    /**
     * Handle click on a locale option:
     * 1. Close the dropdown immediately
     * 2. Re-render the dropdown so the selected option appears as current
     * 3. Navigate to the same page in the selected locale
     */
    handleLocaleOptionClick = (ev) => {
        ev.preventDefault();
        const { localeCode } = ev.currentTarget.dataset;
        if (!localeCode) {
            console.warn('[LocaleSelector] Clicked option has no data-locale-code attribute — ignoring click.');
            return;
        }

        console.info(`[LocaleSelector] Option clicked — switching to locale: "${localeCode}"`);

        setLangSiteCookie(`/${localeCode}.html`);

        // 1. Close dropdown
        this.closeLanguageSelector();

        // 2. Re-render: updates header label + marks clicked option as current
        this.renderLocaleDropdown(localeCode);

        // 3. Navigate (async — happens after the UI has already updated)
        this.goToLocalePage(localeCode);
    };

    /**
     * Navigate to the equivalent page in the selected locale.
     * Handles both production URLs (rockwellautomation.com/en-us/...)
     * and AEM author URLs (localhost:4502/content/.../en-us/... or .../en.html).
     */
    goToLocalePage = async (localeCode) => {
        const { pathname } = window.location;
        let newPathname = null;

        // Replace the current locale code in the path (e.g. /en-us → /de-de)
        LOCALES.some((locale) => {
            const regex = new RegExp(`(\\/)${locale.code}(\\.html|\\/|$)`);
            if (regex.test(pathname)) {
                newPathname = pathname.replace(regex, `$1${localeCode}$2`);
                console.info(`[LocaleSelector] Replaced "/${locale.code}" → "/${localeCode}" in path.`);
                return true;
            }
            return false;
        });

        if (!newPathname) {
            console.warn(`[LocaleSelector] No locale segment (xx-xx) found in path "${pathname}" — navigation aborted.`);
            return;
        }

        // Build the full URL preserving query params
        const newUrl = new URL(window.location.href);
        newUrl.pathname = newPathname;
        const preferredHref = newUrl.href;

        console.info(`[LocaleSelector] Attempting navigation to: ${preferredHref}`);

        try {
            const response = await fetch(preferredHref, { method: 'HEAD' });
            if (response.ok) {
                console.info(`[LocaleSelector] Page exists — navigating to: ${preferredHref}`);
                window.location.href = preferredHref;
                return;
            }
            console.warn(`[LocaleSelector] Page returned ${response.status} — falling back to locale root.`);
        } catch (e) {
            console.warn(`[LocaleSelector] Fetch failed for "${preferredHref}" (${e.message}) — falling back to locale root.`);
        }

        // Fallback: navigate to the locale root (strip everything after the locale segment)
        const fallbackMatch = newPathname.match(new RegExp(`(.*\\/${localeCode})`));
        const fallbackPath = fallbackMatch ? fallbackMatch[1] : `/${localeCode}`;
        const fallbackHref = `${window.location.origin}${fallbackPath}`;
        console.info(`[LocaleSelector] Navigating to fallback locale root: ${fallbackHref}`);
        window.location.href = fallbackHref;
    };

    // ==========
    // Menu Close
    // ==========
    closeOnClickaway = (ev) => {
        if(onSearchResultPage) {
            return;
        }
        // Quicklinks Menu
        if (!this.elements.quicklinksWrapper?.contains(ev.target)) {
            this.closeQuicklinksMenu();
        }
        // eslint-disable-next-line no-restricted-globals
        if (!this.elements.mainHeader?.contains(ev.target) || (window.innerWidth >= mobileBreakpoint && window.innerWidth < tabletBreakpoint && (ev.pageX < tabletCenterDropdownMargin || ev.pageX > window.innerWidth - tabletCenterDropdownMargin)) || (window.innerWidth >= tabletBreakpoint && (ev.pageX < desktopCenterDropdownMargin || ev.pageX > window.innerWidth - desktopCenterDropdownMargin))) {
            this.closeDropdowns();
        }
        if (this.elements.header.classList.contains(`${componentName}--search-active`) && !this.elements.centerSearchOuterContainer?.contains(ev.target) && !this.elements.searchToggleButton?.contains(ev.target)) {
            this.closeSearch();
        }
        if (window.innerWidth < mobileBreakpoint && !this.elements.mainHeader?.contains(ev.target)) {
            this.closeMobileMenu();
        }
        // Language Selector
        if (
            !this.elements.languageSelectorButton?.contains(ev.target)
            && !this.elements.languageSelectorMobileButton?.contains(ev.target)
            && !this.elements.languageSelectorDropdown?.contains(ev.target)
        ) {
            this.closeLanguageSelector();
        }
    };

    // ==========
    // Mobile
    // ==========
    openMobileMenu = () => {
        this.element.classList.add(this.classes.mobileActive);
        this.elements.supportButtonsContainerMobile.classList.remove('inactive');
        this.elements.utilityHeaderLogoContainerMobile.classList.remove('inactive');
        this.elements.overlay.classList.add(this.classes.active);
    };

    closeMobileMenu = () => {
        this.element.classList.remove(this.classes.mobileActive);
        this.elements.overlay.classList.remove(this.classes.active);
    };

    handleMobileMenuButton = () => {
        this.repositionDropdownContainer();
        // Mobile menu button transforms into search close button when search is open
        if (this.element.classList.contains(this.classes.searchActive)) {
            this.closeSearch();
            return;
        }

        // Otherwise toggles mobile menu
        if (this.element.classList.contains(this.classes.mobileActive)) {
            this.closeMobileMenu();
        } else {
            this.openMobileMenu();
        }
    };

    handleDropdownBackButton = () => {
        this.closeDropdowns();

        // Open Mobile Support Buttons
        this.elements.supportButtonsContainerMobile.classList.remove('inactive');
        this.elements.utilityHeaderLogoContainerMobile.classList.remove('inactive');
        this.elements.overlay.classList.add(this.classes.active);
    };

    repositionDropdownContainer = () => {
        // eslint-disable-next-line no-restricted-globals
        if(window.innerWidth < mobileBreakpoint) {
            const rect = this.elements.mainHeader.getBoundingClientRect();
            this.elements.centerDropdownContainer.style.top = `${rect.bottom}px`;
            this.elements.quicklinksMenu.style.top = `${rect.bottom}px`;
        }
    };

    // ==========
    // Editable Initial Editing
    // ==========
    editableInitialEditing = () => {
        if(!window.location.href.includes('config-pages/header-config.html') && (document.querySelector('[data-path*="config-pages/header-config"]') !== null)) {
            document.querySelectorAll('[data-path*="config-pages/header-config"]').forEach((el) => {
                el.remove();
            });
            document.querySelectorAll('[data-emptytext="Global Nav"]').forEach((el) => {
                el.remove();
            });
            document.querySelectorAll(`.${componentName}-editor-spacer`).forEach((el) => {
                el.remove();
            });
            document.querySelectorAll(`.${componentName}__quicklinks-menu`).forEach((el) => {
                el.remove();
            });
        }
    };

    // ==========
    // Event Listeners
    // ==========
    addEventListeners = () => {
        // Quicklinks
        this.elements.quicklinksButton.addEventListener('click', this.handleQuicklinksButton);
        // Search
        this.elements.searchToggleButton.addEventListener('click', this.handleSearchButton);
        this.elements.searchSubmit.addEventListener('click', this.submitSearch);
        this.elements.searchInput.addEventListener('keyup', (ev) => {
            if (ev.key === 'Enter') {
                this.submitSearch();
            }
        });
        // Dropdown
        this.elements.dropdownLinks.forEach((el) => el.addEventListener('click', this.handleDropdownLink));
        this.elements.dropdownLinks.forEach((el) => el.addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter') {
                this.handleDropdownLink(ev);
            }
        }));
        this.elements.dropdownBackButton.addEventListener('click', this.handleDropdownBackButton);
        // Language Selector
        if (this.elements.languageSelectorButton) {
            this.elements.languageSelectorButton.addEventListener('click', this.handleLanguageSelectorButton);
        }
        if (this.elements.languageSelectorMobileButton) {
            this.elements.languageSelectorMobileButton.addEventListener('click', this.handleLanguageSelectorButton);
        }
        // Mobile Menu Button
        this.elements.mobileMenuButton.addEventListener('click', this.handleMobileMenuButton);
        // Clickaway
        document.addEventListener('click', this.closeOnClickaway);
        // Move Dropdown Component If Header Is Pushed Down
        document.addEventListener('scroll', this.repositionDropdownContainer);
        window.onresize = () => {
            this.repositionDropdownContainer();
        };
        this.elements.dropdownLinks.forEach((el) => {
            el.addEventListener('focus', () => {
                if (this.state.isSearchOpen) {
                    this.closeSearch();
                }
            });
        });
    };

    init() {
        if (this.element?.dataset.globalNavInitialized === 'true') {
            return;
        }
        this.setup();
        if (this.element) {
            this.element.dataset.globalNavInitialized = 'true';
        }
        this.editableInitialEditing();
        this.addEventListeners();
        this.initLocaleSelector();
    }
}

export function initPlexGlobalNav() {
    registerComponent(`.${componentName}`, GlobalNav);
}

document.addEventListener('plex-header-fragment-loaded', initPlexGlobalNav);
initPlexGlobalNav();
